import {
    ADVISORY_LANGUAGE_CANDIDATE_KEYS,
    ADVISORY_VALUE_TYPE_STRING,
    ADVISORY_VALUE_TYPE_OBJECT,
    ADVISORY_ARRAY_ITEMS_SEPARATOR,
    ADVISORY_LANGUAGE_CODE_SEPARATOR,
    ADVISORY_PROPERTY_DISPLAY_NAME_TEXT_KEY,
    ADVISORY_PROPERTY_DISPLAY_NAME,
    ADVISORY_PROPERTY_VALUE,
    ADVISORY_PROPERTY_TEXT,
    ADVISORY_PROPERTY_LABEL
} from './constants';

export const getLocalizedAdvisoryValue = (value, t, i18n) => {
    if (!value) {
        return undefined;
    }

    if (typeof value === ADVISORY_VALUE_TYPE_STRING) {
        return value;
    }

    if (Array.isArray(value)) {
        const items = value
            .map((item) => getLocalizedAdvisoryValue(item, t, i18n))
            .filter(Boolean);

        return items.length ? items.join(ADVISORY_ARRAY_ITEMS_SEPARATOR) : undefined;
    }

    if (typeof value !== ADVISORY_VALUE_TYPE_OBJECT) {
        return undefined;
    }

    if (value[ADVISORY_PROPERTY_DISPLAY_NAME_TEXT_KEY] || value[ADVISORY_PROPERTY_DISPLAY_NAME]) {
        const translated = value[ADVISORY_PROPERTY_DISPLAY_NAME_TEXT_KEY]
            ? t(value[ADVISORY_PROPERTY_DISPLAY_NAME_TEXT_KEY], { defaultValue: value[ADVISORY_PROPERTY_DISPLAY_NAME] || '' })
            : '';

        if (translated && translated !== value[ADVISORY_PROPERTY_DISPLAY_NAME_TEXT_KEY]) {
            return translated;
        }

        return value[ADVISORY_PROPERTY_DISPLAY_NAME] || '';
    }

    const language = (i18n?.resolvedLanguage || i18n?.language || '').toLowerCase();
    const languageFallback = language.split(ADVISORY_LANGUAGE_CODE_SEPARATOR)[0];
    const candidateKeys = [language, languageFallback, ...ADVISORY_LANGUAGE_CANDIDATE_KEYS];

    for (const key of candidateKeys) {
        if (key && typeof value[key] === ADVISORY_VALUE_TYPE_STRING && value[key]) {
            return value[key];
        }
    }

    if (typeof value[ADVISORY_PROPERTY_VALUE] === ADVISORY_VALUE_TYPE_STRING && value[ADVISORY_PROPERTY_VALUE]) {
        return value[ADVISORY_PROPERTY_VALUE];
    }

    if (typeof value[ADVISORY_PROPERTY_TEXT] === ADVISORY_VALUE_TYPE_STRING && value[ADVISORY_PROPERTY_TEXT]) {
        return value[ADVISORY_PROPERTY_TEXT];
    }

    if (typeof value[ADVISORY_PROPERTY_LABEL] === ADVISORY_VALUE_TYPE_STRING && value[ADVISORY_PROPERTY_LABEL]) {
        return value[ADVISORY_PROPERTY_LABEL];
    }

    return undefined;
};
